export default function () {
  return {
    require: ['^form', 'ngModel'],
    scope: {
      total: '='
    },
    link: function (scope, elem, attrs, ctrls) {
      scope.form = ctrls[0];
      var ngModel = ctrls[1];

      scope.$watch(function () {
        return ngModel.$modelValue;
      }, function (value) {
        var namePrefix = 'questionAndAnswers[';

        for (var i = 0; i < scope.total; i++) {
          var isValid = true;
          var prev = namePrefix + i + '].answer';
          for (var j = 0; j < scope.total; j++) {
            if (i != j) {
              var current = namePrefix + j + '].answer';

              var prevAnswer = scope.form[prev].$modelValue;
              var currentAnswer = scope.form[current].$modelValue;
              if (prevAnswer && currentAnswer && prevAnswer == currentAnswer) {
                isValid = false;
                scope.form[current].$setValidity('uniqueanswer', isValid);
              }
            }
          }

          scope.form[prev].$setValidity('uniqueanswer', isValid);
        }
      });
    }
  };
}


// WEBPACK FOOTER //
// ./src/login/securityquestion/uniqueAnswer.directive.js